module.exports = require("three/examples/jsm/loaders/GLTFLoader");